import { render, staticRenderFns } from "./OrderComplaint.vue?vue&type=template&id=050c979e&scoped=true&"
import script from "./OrderComplaint.vue?vue&type=script&lang=js&"
export * from "./OrderComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050c979e",
  null
  
)

export default component.exports